import React from 'react'
import PropTypes from 'prop-types'
import useRect from '../hooks/useRect'

const Gradient = (props) => {
  const { colors, direction } = props

  const [Rect, rect] = useRect()

  const svgDirection = {
    left: { x1: '1', x2: '0', y1: '0', y2: '0' },
    right: { x1: '0', x2: '1', y1: '0', y2: '0' },
    top: { x1: '0', x2: '0', y1: '1', y2: '0' },
    bottom: { x1: '0', x2: '0', y1: '0', y2: '1' },
  }

  return (
    <>
      <Rect />
      <svg
        x={0}
        y={0}
        width={rect.width}
        height={rect.height}
        viewBox={`0 0 ${rect.width} ${rect.height}`}
        data-custom-render="ai-inline-svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
      >
        <defs>
          <linearGradient id="gradient" {...svgDirection[direction]}>
            {colors.map(({ offset, stopColor }, i) => (
              <stop key={i} offset={offset} stopColor={stopColor} />
            ))}
          </linearGradient>
        </defs>
        <path d={`M 0 0 H ${rect.width} V ${rect.height} H 0 V 0`} fill="url(#gradient)" />
      </svg>
    </>
  )
}

Gradient.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      offset: PropTypes.string.isRequired,
      stopColor: PropTypes.string.isRequired,
    })
  ).isRequired,
  direction: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
}

Gradient.defaultProps = {
  direction: 'bottom',
}

export default Gradient
